"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatPostcode;
exports.formatPostcodeRestricted = formatPostcodeRestricted;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _stripWhitespace = _interopRequireDefault(require("../../utils/string/stripWhitespace"));
var _restrictInput = require("./restrictInput");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatPostcode(postcode) {
  if (!(0, _isString["default"])(postcode)) {
    return postcode;
  }
  return (0, _stripWhitespace["default"])(postcode).replace(/.{3}$/, ' $&').toUpperCase();
}
function formatPostcodeRestricted(postcode) {
  var restrictedInput = (0, _restrictInput.uppercaseLettersNumbersSpaces)(postcode);
  return restrictedInput === '' ? restrictedInput : formatPostcode(restrictedInput);
}